import { render, staticRenderFns } from "./MapItemsList.vue?vue&type=template&id=1c49a622&scoped=true"
import script from "./MapItemsList.vue?vue&type=script&lang=js"
export * from "./MapItemsList.vue?vue&type=script&lang=js"
import style0 from "./MapItemsList.vue?vue&type=style&index=0&id=1c49a622&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c49a622",
  null
  
)

export default component.exports